import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { VisitsService } from '../_services/visits.service';
import { GridSelectionService } from '../_services/grid-selection.service';

declare var $: any;

@Component({
  selector: 'app-dropdown-all',
  template: `
    <div class="ag-labeled ag-label-align-right ag-checkbox ag-input-field ag-header-select-all">
      <div
        ref="eLabel"
        class="ag-input-field-label ag-label ag-hidden ag-checkbox-label">
      </div>

      <div
        ref="eWrapper"
        id="ms_AllCheck"
        class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
        [class.ag-checked]="isChecked">

        <input
          class="ag-input-field-input ag-checkbox-input cursor-pointer"
          type="checkbox"
          [checked]="isChecked"
          (change)="toggleSelect()" />
      </div>
    </div>
  `,
  standalone: false
})
export class SelectAllComponent implements IHeaderAngularComp {
  headerName: string = '';
  isChecked = false;
  isIndeterminate = false;
  showCheckBox = true;
  sortIcon = 'none';
  sortSubIcon = 'none';
  params: any;

  constructor(
    private visitService: VisitsService,
    private gridSelectionService: GridSelectionService
  ) {}

  agInit(params: IHeaderParams | any): void {
    this.params = params;
    this.headerName = this.params?.displayName || '';
    this.showCheckBox = this.params?.checkboxSelection ?? true;

    this.params.api.addEventListener('selectionChanged', () => {
      this.setCheckboxState();
    });

    this.gridSelectionService.clearSelectAll$.subscribe(() => {
      this.isChecked = false;
      this.checkdata();
    });

    this.checkdata();
  }

  toggleSelect(): void {
    this.isChecked = !this.isChecked;
    this.visitService.select(this.isChecked);

    if (this.isChecked) {
      $('#ms_AllCheck').addClass('ag-checked');

      this.params?.api?.forEachNode((node: any) => {
        node.setSelected(true);
      });
    } else {
      $('#ms_AllCheck').removeClass('ag-checked');
      this.params?.api?.deselectAll();
    }
  }

  checkdata(): void {
    if (this.isChecked) {
      $('#ms_AllCheck').addClass('ag-checked');

      this.params?.api?.forEachNode((node: any) => {
        node.setSelected(true);
      });
    } else {
      $('#ms_AllCheck').removeClass('ag-checked');
      this.params?.api?.deselectAll();
    }
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    this.setCheckboxState();
    return true;
  }

  private setCheckboxState(): void {
    const selectedNodesLength = this.params?.api?.getSelectedNodes()?.length || 0;
    const displayedRowCount = this.params?.api?.getDisplayedRowCount() || 0;

    this.isChecked =
      selectedNodesLength > 0 && selectedNodesLength === displayedRowCount;

    this.isIndeterminate =
      selectedNodesLength > 0 && selectedNodesLength < displayedRowCount;

    if (this.isChecked) {
      $('#ms_AllCheck').addClass('ag-checked');
    } else {
      $('#ms_AllCheck').removeClass('ag-checked');
    }
  }
}